<template>
    <div>
        <h1 
            class="fs-4 fw-bold text-dark mb-1 lh-sm"
        >
            Reglas de {{(shouldShowAsRecommender().serviceTypeRecommender || shouldShowAsRecommender().neitherService)  ? 'margen' : 'markup'}}
        </h1>
        <p
            class="text-muted small fw-medium "
        >
            Define el rango válido de {{(shouldShowAsRecommender().serviceTypeRecommender || shouldShowAsRecommender().neitherService)  ? 'margen' : 'markup'}}. Los SKUs fuera de este rango serán marcados como críticos.
        </p>
        <TableMarginConfig 
            :active-service-id="activeServiceId"
            @getData="getSearch"
            @change-page="changePage"
            @change-page-size="changePageSize"
            @viewModal="viewModal"
            @filterConfigStatus="updateConfigStatus"
            :products="productList"
            :loading="loading"
            :total-count="totalProducts"
            :current-page="currentPage"
            :page-size="pageSize"
        />
        <!-- Modal -->
        <modal-form
            v-if="propHead.open"
            :propSize="propForm.size"
            :propHead="propHead"
            @closeModal="closeModal"
        >
            <template slot="form">
                <component :is="componentName" :propHead="propHead" :active-service-id="activeServiceId" @refrest="refrest" @closeModal="closeModal"/>
            </template>
        </modal-form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import {  shouldShowAsRecommender } from '../../../../../utils/servicesValidation.js'
import configsRecModuleMixin from '../mixins/configsRecModuleMixin';
import TableMarginConfig from './TableMarginConfig.vue';
import ModalForm from "../../../../../components/modal.vue";
import ConfigMarginOne from './configMarginOne.vue';
import ConfigMarginGroup from './configMarginGroup.vue';
import ConfigMarginOptions from './configMarginOptions.vue';

export default {
    name: 'config-margin',
    mixins: [configsRecModuleMixin],
    components: {
        TableMarginConfig,
        ModalForm,
        ConfigMarginOne,
        ConfigMarginGroup,
        ConfigMarginOptions
    },
    props: {
        activeServiceId: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            propHead: {
                action: "",
                open: false,
                module: "margen",
                text : ""
            },
            propForm: {
                size: "",
                form: "",
            },
            componentName: null,
            marginConfigStatus:''
        };
    },
    methods: {
        ...mapActions(["executeCommit"]),
        buildUrl() {
            return `/api/products/list_config_margin/?${this.buildCommonParams()}&margin_config_status=${this.marginConfigStatus}&prop_extra_3=VIGENTE&service_id=${this.activeServiceId}`;
        },
        viewModal(row,name,title,text) {
            this.componentName = name;
            this.propForm.size = false
            this.propHead = {
                action: title,
                open: true,
                row: row,
                text: text,
                component:this.componentName,
            }
        },
        closeModal() {
            this.executeCommit({
                mutation: "close_modal",
            });
            this.propHead = {
                action: "",
                open: false,
                module: "margen",
                text: ""
            };
            this.componentName = null;
        },
        refrest() {
            this.closeModal();
            this.fetchData();
        },
        updateConfigStatus(status) {
            this.marginConfigStatus = status;
            this.fetchData();
        },
        /**
         * Verifica si debe mostrar como recomendador (para usar en template)
         */
        shouldShowAsRecommender(user = null) {
            return shouldShowAsRecommender(user || this.authentication_user, this.activeServiceId);
        }
    }
}
</script>
